import {JsonConfigInterface} from './json-config-interface';
import {Utils} from '@astek/utils';

export type CommentIndicatorConfigJson = {
  color: string;
  imageHeight: number;
  margin: number;
  lineWidth: number;
  selectionDistanceThreshold: number;
}

export class CommentIndicatorConfig implements JsonConfigInterface<CommentIndicatorConfigJson> {
  private _color: string = '';
  private _imageHeight: number = 0;
  private _margin: number = 0;
  private _lineWidth: number = 0;
  private _selectionDistanceThreshold: number = 0;

  constructor(json?: CommentIndicatorConfigJson) {
    if (Utils.isNotNullOrUndefined(json)) {
      this.deserializeJson(json);
    }
  }

  public get color(): string {
    return this._color;
  }

  public get imageHeight(): number {
    return this._imageHeight;
  }

  public get margin(): number {
    return this._margin;
  }

  public get lineWidth(): number {
    return this._lineWidth;
  }

  public get selectionDistanceThreshold(): number {
    return this._selectionDistanceThreshold;
  }

  public deserializeJson(json: CommentIndicatorConfigJson): void {
    this._color = json.color;
    this._imageHeight = json.imageHeight;
    this._margin = json.margin;
    this._lineWidth = json.lineWidth;
    this._selectionDistanceThreshold = json.selectionDistanceThreshold;
  }
}
